import Vue from 'vue';
import { mapGetters } from 'vuex';

// This component runs in both admin panel and editor
export default Vue.component('fetch-origin', {
  template: require('./template.html'),
  name: 'fetch-origin',
  computed: {
    ...mapGetters(['useStaging']),
  },
  created() {
    const useStaging = JSON.parse(window.localStorage.getItem('drzUseStagingData'));
    this.$store.dispatch('setDataOrigin', useStaging);
  },
  methods: {
    toggleFetch() {
      this.$store.dispatch('setDataOrigin', !this.useStaging);
      window.localStorage.setItem('drzUseStagingData', this.useStaging);
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/fetch-origin/index.js